<template>
  <div class="c-ads-wrapper">
    <m-content v-model="height" :total="total">
      <!-- filter -->
      <ads-filter ref="adsFilter" slot="filter" :loading="loading" :mediaData="mediaData" @on-search="onSearch" @on-add="addAdvert" />
      <!-- table -->
      <m-table ref="table" :data="tableData" :height="height" :loading="loading" @selection-change="changeSelection">
        <el-table-column
          v-for="(col, id) in tableColumns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
        >
          <template slot-scope="scope">
            <div v-if="col.key === 'control'" class="m-control">
              <a href="javascript:;" class="c-control-margin" @click.prevent="editAdvert(scope.row)">编辑</a>
            </div>
            <span v-else-if="['createTime', 'upTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </m-table>
      <Page
        show-total
        show-sizer
        show-elevator
        slot="pagination"
        class="c-table-page"
        size="small"
        v-if="total"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </m-content>
    <!-- 弹出框 -->
    <ads-edit
      v-model="model"
      title="媒体计划位"
      :editFlag="editFlag"
      :editData="editData"
      :mediaData="mediaData"
      :loading="loading"
      @on-save="saveAds"
      @on-del="delAds"
    />
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { setLocal } from '@/common/js/api'
import { getSysMedia } from '@/api/common.model'
import mixin from '../mixins/mixin'
import AdsEdit from './components/ads-edit'
import tableColumns from '../data/media_advert_columns'
import AdsFilter from './components/ads-filter.vue'
import { queryAdvPosition, addAdvert, updateAdvert, deleteAdvert } from '@/api/media-advert.model'

export default {
  name: 'Ads',
  mixins: [mixin],
  components: { AdsFilter, AdsEdit },
  data() {
    return {
      model: null,
      saving: null,
      loading: null,
      height: 0,
      queryKey: null,
      mediaId: null,
      tableData: [],
      tableColumns: [],
      access: this.$store.state.accessAuth,
      selectionRow: [],
      editData: {},
      editFlag: '',
      mediaData: []
    }
  },
  mounted() {
    this.preLoadData()
    this.getData()
  },
  methods: {
    changeSelection(val) {
      if (isArray(val)) {
        this.selectionRow = val.map((e) => {
          return e
        })
      }
    },
    setLocalPage(size) {
      setLocal('PAGESIZE', size)
    },
    onSearch(params) {
      this.queryKey = params.keyword
      this.mediaId = params.mediaId
      this.getData()
    },
    addAdvert() {
      this.editFlag = 'add'
      this.editData = {
        mediaId: null,
        advertPosiId: null,
        advertPosiName: '',
        advertPosiDesc: ''
      }
      this.model = true
    },
    editAdvert(row) {
      console.log(row)
      this.editFlag = 'edit'
      this.editData = {
        mediaId: row.mediaId,
        mediaName: row.mediaName,
        advertPosiId: row.advertPosiId,
        advertPosiName: row.advertPosiName,
        advertPosiDesc: row.advertPosiDesc
      }
      this.model = true
    },
    saveAds(params) {
      if (this.editFlag === 'add') {
        this.loading = true
        addAdvert(params)
          .then((data) => {
            this.loading = false
            if (data) {
              this.$Message.success('保存成功!')
              this.model = false
              this.pageIndex = 1
              this.$refs.adsFilter.setQueryKey('')
              this.getData()
            }
          })
          .catch(() => {
            this.loading = false
            this.$Message.success('保存失败!')
          })
      } else if (this.editFlag === 'edit') {
        this.loading = true
        updateAdvert(params)
          .then((data) => {
            this.loading = false
            if (data) {
              this.$Message.success('保存成功!')
              this.model = false
              this.getData()
            }
          })
          .catch(() => {
            this.loading = false
            this.$Message.success('保存失败!')
          })
      }
    },
    delAds(params) {
      this.loading = true
      deleteAdvert(params)
        .then((data) => {
          this.loading = false
          if (data) {
            this.$Message.success('删除成功!')
            this.model = false
            this.getData()
          }
        })
        .catch(() => {
          this.loading = false
          this.$Message.success('删除失败!')
        })
    },
    getData() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        key: this.queryKey,
        mediaId: this.mediaId
      }
      this.loading = true
      queryAdvPosition(params)
        .then((data) => {
          this.loading = false
          if (data) {
            if (!data) {
              return
            }
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.pageIndex = page_info.page_id
              this.tableColumns = tableColumns
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    preLoadData() {
      Promise.all([getSysMedia()])
        .then((data) => {
          const [mediaData] = data
          this.mediaData = mediaData
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.c-ads-wrapper {
  height: 100%;

  .c-control-margin {
    display: inline-block;
    margin-left: 8px;
  }

  .m-edit {
    cursor: pointer;
  }

  .tag-wrap {
    width: 88%;
    display: inline-block;
  }

  ::v-deep .ivu-tag .ivu-tag-text {
    width: auto;
  }

  .c-table-page {
    padding: 0 8px;
    margin-top: 6px;
    text-align: right;
  }

  ::v-deep .el-table__row {
    height: 49px;
  }
}
</style>
